// YERİ: src/app/domains/site/core/stripe-loader.ts
//
// Stripe.js yükleyici.
//
// NEDEN npm PAKETİ DEĞİL: Stripe, kart alanlarını çizen betiğin KENDİ
// alanlarından (js.stripe.com) yüklenmesini şart koşuyor — PCI kapsamını
// daraltan şey bu. `@stripe/stripe-js` paketi de aynı betiği oradan çekiyor;
// yaptığı iş bir <script> etiketi eklemek. Ek bağımlılık taşımamak için
// yükleyiciyi kendimiz yazıyoruz.
//
// SSR: sunucuda document yok — orada asla çağrılmamalı, çağrılırsa null döner.

const STRIPE_JS = 'https://js.stripe.com/v3/';

/** Stripe.js'in bize lazım olan yüzeyi; tam tipleri taşımıyoruz. */
export interface StripeLike {
  // `locale` belongs on BOTH the constructor and elements(): the field labels
  // and Stripe's own validation errors live inside Stripe's iframe, so they
  // stay English unless Stripe is told the visitor's language.
  elements(opts: { clientSecret: string; appearance?: unknown; locale?: string }): StripeElementsLike;
  confirmPayment(opts: {
    elements: StripeElementsLike;
    confirmParams?: { return_url?: string };
    redirect?: 'if_required';
  }): Promise<{ error?: { message?: string }; paymentIntent?: { status?: string } }>;
}

export interface StripeElementsLike {
  create(type: 'payment', opts?: unknown): StripeElementLike;
}

export interface StripeElementLike {
  mount(selector: string | HTMLElement): void;
  unmount(): void;
}

export interface StripeInitOptions { locale?: string }

type StripeCtor = (publishableKey: string, options?: StripeInitOptions) => StripeLike;

let loading: Promise<StripeCtor | null> | null = null;

function loadScript(): Promise<StripeCtor | null> {
  if (typeof document === 'undefined') return Promise.resolve(null); // SSR

  const existing = (window as unknown as { Stripe?: StripeCtor }).Stripe;
  if (existing) return Promise.resolve(existing);

  return new Promise(resolve => {
    const el = document.createElement('script');
    el.src = STRIPE_JS;
    el.async = true;
    el.onload = () => resolve((window as unknown as { Stripe?: StripeCtor }).Stripe ?? null);
    // Ağ engeli / reklam engelleyici betiği düşürebilir. Sessizce null dön;
    // çağıran "kart ödemesi başlatılamadı" der, sayfa çökmez.
    el.onerror = () => resolve(null);
    document.head.appendChild(el);
  });
}

/**
 * Stripe örneği döner. Betik birden çok bileşenden istenebilir; aynı yükleme
 * paylaşılır (iki <script> etiketi eklemeyiz).
 */
export async function loadStripe(
  publishableKey: string,
  options?: StripeInitOptions,
): Promise<StripeLike | null> {
  if (!publishableKey) return null;
  loading ??= loadScript();
  const ctor = await loading;
  return ctor ? ctor(publishableKey, options) : null;
}
